module.exports = __webpack_public_path__ + "assets/img/cpp_test_l1.8702db96.png";